import React, { Component } from 'react'
import { AntennaBottomControl, Button, CustomItemList, Page, Spacer, TagCounter } from 'components'
import { CQTag, CustomTmrItem } from 'api/types'
import QualityControlAgent from 'pages/QualityControl/QualityControlAgent'
import EncodingsCQ from 'api/EncodingsCQ'
import { showToast } from 'shared/utils'
import { T, __ } from 'translations/i18n'

interface State {
  items: CustomTmrItem[]
  tag?: CQTag
  isReading: boolean
}

export default class TagInfoQualityControl extends Component<{}, State> {
  state: State = {
    items: [],
    isReading: false,
  }

  clear = () => this.setState({ items: [] })

  startReader = async () => {
    this.setState({
      isReading: true,
    })
    QualityControlAgent.readTag('fake', 'fake')
      .then((tag) => this.onTagReadCallback(tag as CQTag))
      .catch((error) => {
        console.log(error)
        this.setState({ isReading: false }) //show start reader because readTag is failed and the reader is not reading anymore
      })
  }

  onTagReadCallback = async (tag: CQTag) => {
    try {
      const { items } = this.state
      this.setState({ isReading: false })

      if (tag.status === '1') throw Error(__(T.error.reader_connection_error))
      if (tag.uid === '' || tag.status !== '0') throw Error(__(T.error.read_product_not_valid))

      let item = (await EncodingsCQ.fetchItemByIdentifier(tag.uid))[0]

      if (!item) item = { id: tag.uuid, epc: tag.uid }
      if (items.filter((itm) => itm.id === item.id).length > 0) return
      items.unshift(item)
      this.setState({ items })
    } catch (error) {
      showToast({
        title: __(T.error.error),
        description: error?.message ?? __(T.error.WEBRESOURCE_GENERIC_ERROR),
        status: 'error',
      })
    }
  }

  emulateTag = (tags: string[]) => {
    const tagRead = {
      errorDesc: '',
      status: '0',
      uid: tags[0],
      uuid: tags[0],
    }
    this.onTagReadCallback(tagRead)
  }

  render() {
    const { items, isReading } = this.state

    return (
      <Page title={__(T.titles.tag_info)} enableEmulation emulationFunction={this.emulateTag}>
        <Page.Sidebar>
          <TagCounter detected={items.length} />
          {!isReading && <Button title={__(T.placeholder.start_reader)} onClick={this.startReader} />}
          <Spacer />
          {items.length > 0 && <Button variant={'secondary'} title={__(T.misc.reset)} onClick={this.clear} />}
        </Page.Sidebar>

        <Page.Content>
          <CustomItemList items={items} emptyMessage={isReading ? __(T.messages.near_product_to_reader) : undefined} />
          {isReading && <AntennaBottomControl />}
        </Page.Content>
      </Page>
    )
  }
}
